export default __webpack_public_path__ + "static/media/112-person.30c59f0d.svg";